import { combineReducers } from "redux";
import auth from './auth/reducer';
import purchaseSim from './inventory/purchaseSim/reducer'
import generic from './generic/reducer'
import reports from './reports/reducer'
import inventoryTransfer from './inventory/inventoryTransfer/reducer'
import activation from './activation/reducer'
import dealer from './dealer/reducer';
import user from './user/reducer';
import pageAccess from './pageAccess/reducer';
import swap from './swap/reducer';
import checkStatus from './checkStatus/reducer';
import recharge from './recharge/reducer';
import wifiActivation from './wifiActivation/reducer';
import planPriceConfig from './planPriceMapping/reducer';



const rootReducer = combineReducers({
  auth,
  purchaseSim,
  generic,
  reports,
  inventoryTransfer,
  activation,
  dealer,
  user,
  pageAccess,
  swap,
  checkStatus,
  recharge,
  wifiActivation,
  planPriceConfig

});
export default rootReducer;